// extracted by mini-css-extract-plugin
export default {"headAd":"index_headAd_nw3QX","main":"index_main_UADqW","aside":"index_aside_YQQBo","qrcode":"index_qrcode_eMJts"};